import React ,{useState,useEffect} from 'react';

import ArticleForm from '../../componenents/Forms/ArticleForm';
import BackButton from '../../componenents/Buttons/BackButton';
import { fetchCategoriesService, fetchSubCategoriesService } from '../../services/CategoryService';
import { Button, Typography, Row, Col } from 'antd';

import '../../styles/CreateArticle.css';
import EditArticleForm from '../../componenents/Forms/ArticleEditingForm';
import { useQuery } from '@apollo/client';
import { FIND_UNIQUE_ARTICLE } from '../../services/ArticleService';
import { useParams } from 'react-router-dom';

const { Title } = Typography;
const EditArticlePage = () => {
  const [userId,setUserId] = useState(null);
  const [article,setArticle] = useState(null);

    const { id } = useParams(); // Get the article ID from route params


    useEffect(() => {
      // Fetch categories from the article service
      const auth = localStorage.getItem('authToken')!=null ? true :false;
      setAuth(auth);
      //console.log(auth);
      const loadCategories = async () => {
        try {
          const fetchedCategories = await fetchCategoriesService(); // Fetch categories from the service
          setCategories(fetchedCategories); // Set the categories
          const fetchedSubCategories = await fetchSubCategoriesService(); // Fetch categories from the service
          setSubCategories(fetchedSubCategories); // Set the categories
         // console.log(subcategories);
        } catch (error) {
          console.error('Failed to load categories', error); // Handle any errors
        } finally {
          setLoading(false); // Stop loading after fetching the categories
        }
      };
  
      loadCategories();
    }, []);
    // GraphQL query to fetch the article details
    const { loadings, error, data } = useQuery(FIND_UNIQUE_ARTICLE, {
      variables: { id: parseInt(id, 10) }, // Pass articleId as a variable
    });
  
    const article1 = data?.findUniqueArticle;
    useEffect(() => {
      if (article1 && (article1.authorId !== parseInt(localStorage.getItem('userId')) && localStorage.getItem('roleType')!='ADMIN')) {
        window.location.href = '/admin/articles'; // Redirect to the article page
      }else{
       setArticle(article1);
      }
    }, [article1]);
   // console.log(article1);

  const [categories, setCategories] = useState([]);
  const [subcategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [auth, setAuth] = useState(false); // Loading state



 
  return (
    <div className="create-article-container">
      {article == null ? (
        <div className="loading-container">
          <Typography.Text>Loading...</Typography.Text>
        </div>
      ) : (
        <Row justify="center">
          <Col xs={24} md={20} lg={16}>
            {/* Back Button */}
            <div className="back-button">
              <BackButton />
            </div>

            {/* Title */}
            <Title level={2} style={{ marginBottom: '30px', textAlign: 'center' }}>
              Edit Article
            </Title>

            {/* Article Form */}
            <div className="article-form-wrapper">
              <EditArticleForm categories={categories} subCategories={subcategories} initialValues={article} />
            </div>
          </Col>
        </Row>
      )}
    </div>
  );

};

export default EditArticlePage;
